import { transport } from 'config/transport';

export function callApiGetListOfDuThu(congDoanId, gradeId) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${gradeId}/duthu`);
}
